import moment from "moment";
import { env } from "../common/lib";

export default {
    /**
     * Get account initial state
     */
    account: () => ({
        displayName: "",
        email: "",
        firstName: "",
        groups: [],
        surname: ""
    }),
    /**
     * Get audit filters initial state
     */
    auditFilters: () => ({
        /** Commenting assetTypes categories and makes to match requirement*/
        // assetTypes: [],
        // categories: [],
        // makes: [],
        monetaryValueSampling: 0,
        randomValueSampling: 100
        // maxValue: env.asset.maxValue,
        // minValue: 0,
    }),
    /**
     * Get audit group initial state
     */
    auditGroup: () => ({
        name: "",
        startDate: null,
        endDate: null,
        closedDate: null
    }),
    /**
     * Get branch initial state
     */
    branch: () => ({ branchRef: [], name: "" }),
    /**
     * Get finance-type initial state
     */
    financeType: () => ({ financeTypeRef: [], name: "" }),
    /**
     * Get list initial state
     */
    list: () => ({ byId: {}, data: [], item: null }),
    /**
     * Get location initial state
     */
    location: () => ({ branch: null, locationRef: [], name: "" })
};
